var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColourLightBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 560 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monochrome-dark-background",
    serifId: "monochrome dark background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bigger-dots",
    serifId: "bigger dots"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "monochrome-light-background",
    serifId: "monochrome light background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bigger-dots1",
    serifId: "bigger dots"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "colour-dark-background",
    serifId: "colour dark background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bigger-dots2",
    serifId: "bigger dots"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "colour-light-background",
    serifId: "colour light background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M178.608,74.205l0,10.854l-49.667,0l0,-69.708l48.343,0l0,10.854l-36.044,0l0,18.125l31.976,0l0,10.655l-31.976,0l0,19.22l37.368,0Z",
    style: {
      fill: "#26495e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.947,9.301l0,75.758l-12.252,0l0,-7.045c-2.11,2.587 -4.714,4.527 -7.811,5.82c-3.097,1.293 -6.517,1.94 -10.261,1.94c-5.241,0 -9.955,-1.157 -14.141,-3.472c-4.186,-2.314 -7.47,-5.598 -9.853,-9.852c-2.382,-4.254 -3.573,-9.138 -3.573,-14.652c0,-5.513 1.191,-10.38 3.573,-14.6c2.383,-4.22 5.667,-7.487 9.853,-9.801c4.186,-2.315 8.9,-3.472 14.141,-3.472c3.607,0 6.909,0.613 9.904,1.838c2.995,1.225 5.547,3.063 7.657,5.513l0,-27.975l12.763,0Zm-28.793,65.548c3.063,0 5.82,-0.698 8.27,-2.093c2.451,-1.395 4.391,-3.386 5.82,-5.973c1.43,-2.586 2.144,-5.581 2.144,-8.985c0,-3.403 -0.714,-6.398 -2.144,-8.984c-1.429,-2.587 -3.369,-4.578 -5.82,-5.973c-2.45,-1.396 -5.207,-2.093 -8.27,-2.093c-3.063,0 -5.819,0.697 -8.27,2.093c-2.45,1.395 -4.39,3.386 -5.819,5.973c-1.43,2.586 -2.145,5.581 -2.145,8.984c0,3.404 0.715,6.399 2.145,8.985c1.429,2.587 3.369,4.578 5.819,5.973c2.451,1.395 5.207,2.093 8.27,2.093Z",
    style: {
      fill: "#26495e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.762,30.538l0,46.251c0,19.195 -9.802,28.792 -29.405,28.792c-5.241,0 -10.21,-0.663 -14.906,-1.991c-4.697,-1.327 -8.577,-3.25 -11.64,-5.768l5.718,-9.598c2.382,1.974 5.394,3.557 9.036,4.748c3.641,1.191 7.334,1.787 11.078,1.787c5.989,0 10.38,-1.362 13.17,-4.084c2.791,-2.723 4.187,-6.875 4.187,-12.457l0,-2.858c-2.179,2.382 -4.833,4.186 -7.964,5.411c-3.131,1.225 -6.569,1.838 -10.312,1.838c-5.173,0 -9.853,-1.106 -14.039,-3.318c-4.186,-2.213 -7.487,-5.327 -9.904,-9.343c-2.416,-4.016 -3.624,-8.61 -3.624,-13.783c0,-5.173 1.208,-9.751 3.624,-13.733c2.417,-3.981 5.718,-7.062 9.904,-9.24c4.186,-2.178 8.866,-3.267 14.039,-3.267c3.947,0 7.538,0.647 10.771,1.94c3.233,1.293 5.939,3.267 8.117,5.922l0,-7.249l12.15,0Zm-29.098,41.248c4.832,0 8.797,-1.446 11.894,-4.339c3.097,-2.893 4.646,-6.654 4.646,-11.282c0,-4.561 -1.549,-8.27 -4.646,-11.129c-3.097,-2.859 -7.062,-4.288 -11.894,-4.288c-4.901,0 -8.9,1.429 -11.997,4.288c-3.097,2.859 -4.646,6.568 -4.646,11.129c0,4.628 1.549,8.389 4.646,11.282c3.097,2.893 7.096,4.339 11.997,4.339Z",
    style: {
      fill: "#26495e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.719,58.105c0,0.885 -0.068,2.144 -0.205,3.777l-42.779,0c0.748,4.016 2.705,7.199 5.87,9.547c3.165,2.348 7.096,3.522 11.793,3.522c5.99,0 10.925,-1.974 14.804,-5.922l6.841,7.862c-2.45,2.927 -5.547,5.139 -9.291,6.637c-3.744,1.497 -7.964,2.246 -12.66,2.246c-5.99,0 -11.266,-1.191 -15.826,-3.574c-4.56,-2.382 -8.083,-5.7 -10.567,-9.954c-2.485,-4.255 -3.727,-9.07 -3.727,-14.448c0,-5.309 1.208,-10.09 3.625,-14.345c2.416,-4.254 5.768,-7.572 10.056,-9.954c4.289,-2.383 9.121,-3.574 14.499,-3.574c5.309,0 10.056,1.174 14.243,3.523c4.186,2.348 7.453,5.649 9.801,9.903c2.348,4.254 3.523,9.172 3.523,14.754Zm-27.567,-17.97c-4.084,0 -7.539,1.208 -10.364,3.625c-2.824,2.416 -4.543,5.632 -5.156,9.648l30.937,0c-0.545,-3.948 -2.212,-7.147 -5.003,-9.597c-2.791,-2.451 -6.262,-3.676 -10.414,-3.676Z",
    style: {
      fill: "#26495e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.995,26.305l-23.103,0l0,-10.954l59.152,0l0,10.954l-23.103,0l0,58.754l-12.946,0l0,-58.754Z",
    style: {
      fill: "#26495e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.325,
    y: 32.485,
    width: 12.763,
    height: 52.575,
    style: {
      fill: "#26495e"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.325,
    y: 15.351,
    width: 12.763,
    height: 10.954,
    style: {
      fill: "#26495e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.044,58.105c0,0.885 -0.068,2.144 -0.204,3.777l-42.78,0c0.749,4.016 2.706,7.199 5.871,9.547c3.165,2.348 7.096,3.522 11.793,3.522c5.989,0 10.924,-1.974 14.804,-5.922l6.841,7.862c-2.451,2.927 -5.548,5.139 -9.291,6.637c-3.744,1.497 -7.964,2.246 -12.661,2.246c-5.99,0 -11.265,-1.191 -15.825,-3.574c-4.561,-2.382 -8.083,-5.7 -10.568,-9.954c-2.484,-4.255 -3.726,-9.07 -3.726,-14.448c0,-5.309 1.208,-10.09 3.624,-14.345c2.417,-4.254 5.769,-7.572 10.057,-9.954c4.288,-2.383 9.121,-3.574 14.498,-3.574c5.31,0 10.057,1.174 14.243,3.523c4.186,2.348 7.454,5.649 9.802,9.903c2.348,4.254 3.522,9.172 3.522,14.754Zm-27.567,-17.97c-4.084,0 -7.538,1.208 -10.363,3.625c-2.825,2.416 -4.543,5.632 -5.156,9.648l30.936,0c-0.544,-3.948 -2.212,-7.147 -5.002,-9.597c-2.791,-2.451 -6.263,-3.676 -10.415,-3.676Z",
    style: {
      fill: "#26495e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.873,38.502c3.675,-5.718 10.142,-8.577 19.399,-8.577l0,12.15c-1.089,-0.204 -2.076,-0.306 -2.961,-0.306c-4.969,0 -8.849,1.446 -11.64,4.339c-2.79,2.893 -4.186,7.062 -4.186,12.507l0,26.444l-12.762,0l0,-54.521l12.15,0l0,7.964Z",
    style: {
      fill: "#26495e",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "bigger-dots3",
    serifId: "bigger dots"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.326,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear2)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear3)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear4)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.199,
    cy: 93.021,
    r: 6.856,
    style: {
      fill: "url(#_Linear5)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear6)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear7)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.326,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear8)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear9)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear10)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.199,
    cy: 75.895,
    r: 6.856,
    style: {
      fill: "url(#_Linear11)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 58.768,
    r: 6.856,
    style: {
      fill: "url(#_Linear12)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 58.768,
    r: 6.856,
    style: {
      fill: "url(#_Linear13)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 58.768,
    r: 6.856,
    style: {
      fill: "url(#_Linear14)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 58.768,
    r: 6.856,
    style: {
      fill: "url(#_Linear15)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 41.642,
    r: 6.856,
    style: {
      fill: "url(#_Linear16)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 41.642,
    r: 6.856,
    style: {
      fill: "url(#_Linear17)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 41.642,
    r: 6.856,
    style: {
      fill: "url(#_Linear18)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 41.642,
    r: 6.856,
    style: {
      fill: "url(#_Linear19)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear20)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92.578,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear21)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.326,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear22)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear23)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear24)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.199,
    cy: 24.515,
    r: 6.856,
    style: {
      fill: "url(#_Linear25)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.946,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear26)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.326,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear27)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.452,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear28)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.073,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear29)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.199,
    cy: 7.389,
    r: 6.856,
    style: {
      fill: "url(#_Linear30)"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear17",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear18",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear19",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear20",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear21",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear22",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear23",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear24",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear25",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear26",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear27",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear28",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear29",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear30",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.08303e-15,99.3433,-99.3433,6.08303e-15,49.1259,0.53334)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5bd36e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#419bdc",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColourLightBackground);
export default __webpack_public_path__ + "static/media/colour-light-background.408e9350bfa85ee24814421e63bee3a6.svg";
export { ForwardRef as ReactComponent };